export const PACKAGE_NAME = 'jiraIssueViewDateFieldsMessage';
export const TEAM_NAME = 'jira-yurree';

export const START_DATE_FIELD_ID = 'customfield_10015';
export const DUE_DATE_FIELD_ID = 'duedate';
